import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "@/context/Providers";
import { money } from "@/lib/api";

export const CartLines = ({ compact = false, onNavigate }) => {
  const { items, update } = useCart();
  if (!items.length) return null;
  return (
    <ul className="divide-y divide-line" data-testid="cart-lines">
      {items.map((i) => (
        <li key={i.key} className="flex gap-4 py-4" data-testid={`cart-line-${i.slug}`}>
          <Link to={`/shop/product/${i.slug}/`} onClick={onNavigate} className="shrink-0">
            <img src={i.image} alt={i.name} width="80" height="80" loading="lazy" className={`${compact ? "h-16 w-16" : "h-20 w-20"} rounded-xl bg-white object-contain p-1`} />
          </Link>
          <div className="min-w-0 flex-1">
            <Link to={`/shop/product/${i.slug}/`} onClick={onNavigate} className="line-clamp-2 text-sm font-semibold text-white hover:text-gold">{i.name}</Link>
            {Object.entries(i.options).map(([k, v]) => <p key={k} className="text-xs text-gray-400">{k}: {v}</p>)}
            <div className="mt-2 flex items-center justify-between gap-2">
              <div className="flex items-center rounded-full border border-line">
                <button type="button" onClick={() => update(i.key, i.quantity - 1)} aria-label={`Decrease quantity of ${i.name}`} className="grid h-9 w-9 place-items-center text-gray-300 hover:text-gold" data-testid={`cart-line-decrease-${i.slug}`}><Minus className="h-4 w-4" /></button>
                <span className="w-7 text-center text-sm font-semibold" aria-live="polite" data-testid={`cart-line-qty-${i.slug}`}>{i.quantity}</span>
                <button type="button" onClick={() => update(i.key, i.quantity + 1)} aria-label={`Increase quantity of ${i.name}`} className="grid h-9 w-9 place-items-center text-gray-300 hover:text-gold" data-testid={`cart-line-increase-${i.slug}`}><Plus className="h-4 w-4" /></button>
              </div>
              <span className="text-sm font-semibold text-white">{money(i.unit_price * i.quantity)}</span>
              <button type="button" onClick={() => update(i.key, 0)} aria-label={`Remove ${i.name}`} className="grid h-9 w-9 place-items-center text-gray-500 hover:text-red-400" data-testid={`cart-line-remove-${i.slug}`}><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};
